export default __webpack_public_path__ + "static/media/ncobra.e82cb3df.png";